export default "__VITE_ASSET__0MeDyPIi__"